export default __webpack_public_path__ + "static/media/budget-i.8699561d.svg";